// extracted by mini-css-extract-plugin
export default {"VehicleItem":"VehicleItem_VehicleItem__C7KPK"};